<template>
  <div class="BookFrom">
    <mu-container style="margin-top:10px;">
      <mu-form ref="BookInfo" :model="BookInfo" label-position="right" class="mu-demo-form" label-width="80">
        <mu-form-item :rules="UserNameRules" prop="UserName" label="经办人: ">
          <mu-text-field v-model="BookInfo.UserName"/>
        </mu-form-item>
        <mu-form-item :rules="MobileRules" prop="Mobile" label="电话: ">
          <mu-text-field v-model="BookInfo.Mobile" type="number"/>
        </mu-form-item>
        <mu-form-item :rules="CompNameRules" prop="CompName" label="申请单位: ">
          <mu-text-field v-model="BookInfo.CompName"/>
        </mu-form-item>
        <mu-form-item :rules="UserWithNameRules" prop="UserWithName" label="来访人员: ">
          <mu-text-field v-model="BookInfo.UserWithName"/>
        </mu-form-item>
        <mu-form-item :rules="UserWithNumRules" prop="UserWithNum" label="来访人数: ">
          <mu-text-field v-model="BookInfo.UserWithNum" type="number"/>
        </mu-form-item>
        <mu-form-item :rules="VistUserNameRules" prop="VistUserName" label="陪同人员: ">
          <mu-text-field v-model="BookInfo.VistUserName"/>
        </mu-form-item>
        <mu-form-item :rules="VistNumRules" prop="VistNum" label="陪同人数: ">
          <mu-text-field v-model="BookInfo.VistNum" type="number"/>
        </mu-form-item>
      </mu-form>
    </mu-container>

    <mu-container style="margin-bottom:10px;">
      <mu-button full-width color="primary" @click="Submit">提交</mu-button>
    </mu-container>
    <mu-container style="margin-bottom:34px;">
      <mu-button full-width @click="GoBack">返回</mu-button>
    </mu-container>

    <mu-container>
      <mu-dialog :open.sync="ShowDet" title="预约信息确认" width="360">
        <div>预约时间：{{ BookTime }}</div>
        <div>经办人：{{ BookInfo.UserName }}</div>
        <div>联系电话：{{ BookInfo.Mobile }}</div>
        <div>申请单位：{{ BookInfo.CompName }}</div>
        <div>来访人员：{{ BookInfo.UserWithName }}</div>
        <div>来访人数：{{ BookInfo.UserWithNum }}人</div>
        <div>陪同人员：{{ BookInfo.VistUserName }}</div>
        <div>陪同人数：{{ BookInfo.VistNum }}人</div>
        <mu-button slot="actions" flat color="primary" @click="Book">确定</mu-button>
        <mu-button slot="actions" flat color="primary" @click="ShowDet = !ShowDet">返回修改</mu-button>
      </mu-dialog>
    </mu-container>
  </div>
</template>

<script>
export default {
  name: 'BookFrom',
  props: {
    BookTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      MobileReg: /^[1][3,4,5,7,8,9][0-9]{9}$/,
      UserNameRules: [
        { validate: (val) => !!val, message: '必须填写经办人姓名' },
        { validate: (val) => val.length >= 2, message: '经办人姓名需多于2个字' }
      ],
      MobileRules: [
        { validate: (val) => !!val, message: '必须填写联系电话' },
        { validate: (val) => this.MobileReg.test(val), message: '请填写正确格式的手机号码' }
      ],
      CompNameRules: [
        { validate: (val) => !!val, message: '必须填写申请单位' }
      ],
      UserWithNameRules: [
        { validate: (val) => !!val, message: '必须填写来访人员' }
      ],
      UserWithNumRules: [
        { validate: (val) => !!val, message: '必须填写来访人数' },
        { validate: (val) => val > 0, message: '来访人数需大于0人' }
      ],
      VistUserNameRules: [
        { validate: (val) => !!val, message: '必须填写陪同人员' }
      ],
      VistNumRules: [
        { validate: (val) => !!val, message: '必须填写陪同人数' },
        { validate: (val) => val > 0, message: '陪同人数需大于0人' }
      ],
      BookInfo: {
        UserName: '',
        Mobile: '',
        CompName: '',
        UserWithName: '',
        UserWithNum: '',
        VistUserName: '',
        VistNum: ''
      },
      ShowDet: false,
      clientHeight: ''
    }
  },
  mounted() {
    this.clientHeight = `${document.documentElement.clientHeight}`
    // 然后监听window的resize事件．在浏览器窗口变化时再设置下背景图高度．
    const that = this
    window.onresize = function temp() {
      var NewClientHeight = `${document.documentElement.clientHeight}`
      if (NewClientHeight < that.clientHeight) {
        that.$store.dispatch('setIsShowBottom', false)
      } else {
        that.$store.dispatch('setIsShowBottom', true)
      }
    }
  },
  methods: {
    Submit: function() {
      this.$refs.BookInfo.validate().then((result) => {
        if (result) {
          this.ShowDet = true
        }
      })
    },
    GoBack: function() {
      this.$emit('GoBack')
    },
    Book: function() {
      this.ShowDet = false
      this.$emit('Book', this.BookInfo)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/BookPage/components/BookFrom.vue